"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = require("../../Context");
var _appconfig = require("../../../selectors/appconfig");
var _WithSitemapWrapper = _interopRequireDefault(require("./WithSitemapWrapper"));
var Styled = _interopRequireWildcard(require("../styles/mds"));
var _actions = require("../../../actions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HeaderMenuItem = ({
  item,
  isActive,
  href,
  onClick,
  history
}) => {
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const itemNode = (0, _react.useRef)(null);
  const sitemapItems = item.children;
  const dispatch = (0, _Context.useDispatch)();
  (0, _react.useEffect)(() => {
    const checkItemTruncated = () => {
      if (itemNode.current) {
        var _itemNode$current, _itemNode$current$fir, _itemNode$current2, _itemNode$current2$fi;
        const isTruncated = ((_itemNode$current = itemNode.current) === null || _itemNode$current === void 0 ? void 0 : (_itemNode$current$fir = _itemNode$current.firstChild) === null || _itemNode$current$fir === void 0 ? void 0 : _itemNode$current$fir.scrollWidth) > ((_itemNode$current2 = itemNode.current) === null || _itemNode$current2 === void 0 ? void 0 : (_itemNode$current2$fi = _itemNode$current2.firstChild) === null || _itemNode$current2$fi === void 0 ? void 0 : _itemNode$current2$fi.offsetWidth);
        dispatch((0, _actions.showBurgerMenu)(isTruncated, item.id));
      }
    };
    checkItemTruncated();
    window.addEventListener('resize', checkItemTruncated, false);
    return () => {
      window.removeEventListener('resize', checkItemTruncated);
    };
  }, [dispatch, item]);
  if (appconfig.headerBasedSitemap) {
    return _react.default.createElement(_WithSitemapWrapper.default, {
      sitemapItems: sitemapItems,
      history: history,
      itemNodeRef: itemNode
    }, _react.default.createElement(Styled.ExpandedMenuItem, {
      active: isActive,
      ref: itemNode
    }, _react.default.createElement(Styled.ExpandedMenuLabel, {
      title: item.label,
      href: href,
      onClick: onClick
    }, item.label)));
  }
  return _react.default.createElement(Styled.ExpandedMenuItem, {
    active: isActive,
    ref: itemNode
  }, _react.default.createElement(Styled.ExpandedMenuLabel, {
    title: item.label,
    href: href,
    onClick: onClick
  }, item.label));
};
var _default = exports.default = HeaderMenuItem;